// export const BaseIp = 'http://192.168.29.113:2001/' //---local path (URL)
export const BaseIp = 'https://boarding.jainboardingkolhapur.com/'     //---online path (URL)

export const IMG_BASE_URL = BaseIp + 'uploads/' //---img path (URL)

//===============================================================================================
//===============================================================================================

export const StudentLoginAPI = BaseIp + 'member/MemberLogin' //Student Login API (POST)
export const CheckWhatsAppNumber = BaseIp + 'registration/checkWhatsAppNumber' //Student Wts No Check API (POST)
export const VerifyWhatsAppOtp = BaseIp + 'registration/verifyWhatsAppOtp' //Student Wts OTP Verify API (POST)
export const ChangePassword = BaseIp + 'member/changePassword' //Change Student Password (POST)
export const SendUserOtp = BaseIp + 'member/forgotPassword' //Send Student OTP (POST)
export const ResetPassword = BaseIp + 'member/resetPassword' //Reset Password (POST)

export const StateMaster = BaseIp + 'allsdt/getAllState' //State List (GET)
export const DistrictMaster = BaseIp + 'allsdt/getDistrictById' //District List (GET) (params=> state id)
export const TalukaMaster = BaseIp + 'allsdt/getTalukaById' //Taluka List (GET) (params=> district id)

export const RegistrationAPI =
  BaseIp + 'registration/studentCreateRegistrationForm' //Registration API (POST)
export const CheckEmailWhatsappAPI = BaseIp + 'registration/checkEmail' //Check Email OR Whatsapp No. Already exist or not (POST)

// ======Hostel Fee Payment Form API===========
export const HostelFeePaymentAPI = BaseIp + 'hostel_fee/hostelFeePayment' //Hostel Fee Payment API (PUT) (params=> reg_id)

// ===========AFTER PAYMENT APPROVAL API'S================

export const StudentProfile = BaseIp + 'registration/studentProfile' // Student Profile Data (GET) (params=> reg_id)

// =====Student Dashboard API's=========
export const UpcomingEvents = BaseIp + 'event_master/upcomingEvent' // Student Upcoming Event Data (GET) (params => branch_id/year)

// =====LEAVE APPLICATION=========
export const CreateLeaveApplicationData =
  BaseIp + 'leave/createLeaveApplication' //Create Leave Application (POST)
export const GetLeaveApplicationData = BaseIp + 'leave/getStudentAllLeaves' //Get Leave Application (GET) (params => reg_id)
export const UpdateLeaveApplicationData =
  BaseIp + 'leave/updateLeaveApplication' //Update Leave Application (PUT) (params => id)
export const DeleteLeaveApplicationData =
  BaseIp + 'leave/deleteLeaveApplication' //Delete Leave Application (DELETE) (params => id)

// =====COMPLAINT APPLICATION=========
export const CreateComplaintApplicationData =
  BaseIp + 'complaint/createComplaint' //Create Complaint Application (POST)
export const GetComplaintApplicationData =
  BaseIp + 'complaint/getAllStudentComplaint' //Get Complaint Application (GET) (params => reg_id/year)
export const DeleteComplaintApplicationData =
  BaseIp + 'complaint/deleteComplaint' //Delete Complaint Application (DELETE) (params => id)

//=========Student Attendance===========================
export const GetStudentAttendance =
  BaseIp + 'daily-attendance/getStudentDailyAttendaceReport'
//Get Attendance (GET) (params => branch_id/year)

export const GetEventStudentAttendance =
  BaseIp + 'event_attendance/getStudentEventAttendaceReport'
//Get Event Attendance (GET) (params => branch_id/year)

export const GetMandirStudentAttendance =
  BaseIp + 'mandir-attendance/getStudentMandirAttendaceReport'
//Get Mandir Attendance (GET) (params => branch_id/year)

//Student profile
//http://localhost:2001/registration/studentUpdateRegistrationForm/3
export const editStudentProfile = BaseIp + 'registration/studentUpdateRegistrationForm'


export const reUploadDocuments = BaseIp + 'member/reUploadDocuments'

//---------   reupload-hostel-payment/:reg_id
export const HostelFeeReuploadAPI = BaseIp + 'member/reupload-hostel-payment'